module.exports = __webpack_public_path__ + "static/media/banner.e77df697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/banner.jpg
// module id = 525
// module chunks = 0